import { estimateContextTokens } from "@/server/admin/contextSize";
import type { AgentRunRecord } from "../utils/types";

type ActiveRunsPanelProps = {
  runs: AgentRunRecord[];
  loading: boolean;
};

const formatDuration = (createdAt: string) => {
  const ms = Date.now() - new Date(createdAt).getTime();
  const seconds = Math.floor(ms / 1000);

  if (seconds < 60) return `${seconds}s`;

  const minutes = Math.floor(seconds / 60);

  return `${minutes}m ${seconds % 60}s`;
};

const isStuck = (createdAt: string) =>
  Date.now() - new Date(createdAt).getTime() > 2 * 60 * 1000;

export const ActiveRunsPanel = ({ runs, loading }: ActiveRunsPanelProps) => (
  <section className="admin-card h-full">
    <h2 className="admin-card-title">Active runs</h2>
    {loading ? <p className="admin-empty">Loading…</p> : null}
    {!loading && runs.length === 0 ? (
      <p className="admin-empty">No agents running.</p>
    ) : null}
    {!loading && runs.length > 0 ? (
      <ul className="admin-run-list">
        {runs.map((run) => (
          <li key={run.id} className="admin-run-item">
            <div className="flex items-center justify-between gap-2">
              <span className="text-xs font-medium text-[var(--admin-text)]">
                {run.id.slice(0, 8)}…
              </span>
              <span className="text-xs text-[var(--admin-muted)]">
                {formatDuration(run.createdAt)}
                {isStuck(run.createdAt) ? " · stuck" : ""}
              </span>
            </div>
            <p className="mt-1 text-sm text-[var(--admin-muted)] line-clamp-2">
              {run.senderPhone ? `${run.senderPhone} · ` : ""}
              {run.inboundPreview ?? "No preview"}
            </p>
            <p className="mt-1 text-xs text-[var(--admin-label)]">
              ~{estimateContextTokens(run.contextSnapshot).toLocaleString()} tok in
              {" · "}
              {run.contextSnapshot.conversationHistoryCount} msgs
              {" · "}
              {run.contextSnapshot.turbopufferMemoryCount} memories
            </p>
          </li>
        ))}
      </ul>
    ) : null}
  </section>
);
